<template>
  <v-dialog v-model="dialog" width="800px" @keydown.esc="hide">
    <v-form>
      <v-card>
        <v-card-title class="card-panel teal lighten-2">
          {{ form.contactID ? 'Редактирование контакта' : 'Новый контакт' }}
        </v-card-title>
        <v-container>
          <v-row>
            <v-col cols="4" class="py-0">
              <v-text-field
                v-model.trim="form.contactFName"
                autofocus
                prepend-icon="mdi-account-circle-outline"
                persistent-hint
                hint="Имя"
                :error-messages="$v.form.contactFName.$invalid ? 'Введите имя' : ''"/>
            </v-col>
            <v-col cols="4" class="py-0">
              <v-text-field v-model.trim="form.contactMName" persistent-hint hint="Отчество"/>
            </v-col>
            <v-col cols="4" class="py-0">
              <v-text-field v-model.trim="form.contactLName" persistent-hint hint="Фамилия"/>
            </v-col>
          </v-row>

          <v-text-field v-model.trim="form.contactEmail" prepend-icon="mdi-mail" persistent-hint hint="E-mail"/>

          <v-text-field
            v-for="(phone, index) in phones" :key="`phone-${index}`"
            v-model.trim="phones[index]"
            type="tel"
            prepend-icon="mdi-phone"
            persistent-hint
            :hint="'Телефон '+(index ? index+1 : '')"
            v-mask="'+380 XX XXX-XX-XX'"
            :append-outer-icon="index ? 'mdi-delete-forever' : 'mdi-plus'"
            @click:append-outer="phoneAction(index)"
          />

          <v-autocomplete v-if="!form.contactID" v-model="form.companyID"
            :items="companiesItems"
            prepend-icon="mdi-domain"
            hint="Компания"
            clearable
          />

          <v-text-field v-if="!form.contactID"
            v-model.trim="form.staffPost"
            prepend-icon="mdi-account"
            persistent-hint
            hint="Должность"
            :disabled="!form.companyID"
            :error-messages="verrStaffPost"/>

          <v-text-field v-if="!form.contactID"
            v-model.trim="form.staffDept"
            prepend-icon="mdi-account-group"
            persistent-hint
            hint="Департамент"
            :disabled="!form.companyID"
          />

        </v-container>

        <v-card-actions>
          <v-btn
            raised
            @click="hide()">Отмена</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            raised
            color="primary"
            :loading="loading"
            :disabled="$v.$invalid"
            @click.prevent="submitAction">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script type="text/javascript">
import { mask } from 'vue-the-mask'
import { validationMixin } from 'vuelidate'
import { combinedObject } from '@/common.js'
import { required, requiredIf } from 'vuelidate/lib/validators'
import api from '@/api'

export default {
  mixins: [ validationMixin ],
  directives: {
    mask,
  },
  data: () => ({
    dialog: false,
    loading: false,
    form: {},
    phones: [],
    companies: []
  }),
  validations: {
    form: {
      contactFName: { required },
      staffPost: { required: requiredIf((model) => (!model.contactID && model.companyID)) }
    }
  },
  computed: {
    companiesItems () { return this.companies.map(cur => ({ value: cur.companyID, text: cur.companyName.substr(0, 80)})) },
    verrStaffPost () { return !this.$v.form.staffPost.$dirty ? [] :
        !this.$v.form.staffPost.required ? 'Введите должность' : [] }
  },
  methods: {
    create () {
      this.form = {}
      this.phones = ['']
      if ( this.companies.length )
      {
        this.dialog = true
      }
      else
        api.get('companies/list').then(response => {
          if ( response.data.$result !== 'ok' ) return this.$root.$alert(response.data.data, true)
          this.companies = combinedObject(response.data.data.cols, response.data.data.rows)
          this.dialog = true
        }).catch(error => (this.$root.$alert(error, true)) )
    },
    edit (data) {
      this.form = Object.assign({}, data)
      this.phones = this.form.contactPhone.split(',')
      this.dialog = true
    },
    hide () {
      this.dialog = false
    },
    phoneAction (index) {
      if ( 0 == index )
      {
        if ( this.phones[this.phones.length-1] !== '' ) this.phones.push('')
      }
      else
        this.phones.splice(index, 1)
    },
    submitAction () {
      if ( this.$v.$invalid ) return
      this.form.contactPhone = this.phones.join(',').replace(/,,/g, ',').replace(/^,/, '').replace(/,$/, '')
      this.loading = true
      api.post('contacts/'+(this.form.contactID ? 'update/'+this.form.contactID : 'create'), this.form).then(response => {
        this.loading = false
        if ( response.data.$result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.dialog = false
        this.$root.$alert('Контакт ' + (this.form.contactID ? 'сохранен' : 'добавлен'))
        this.$emit('updated')
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    }
  }
}
</script>

<style>
.v-list-item { min-height: 30px !important }
.v-list-item__content { padding: 7px 0; }
</style>
